<!-- 需要打印标签的商品列表 -->
<template>
    <div class="searchAp-ctn">
        <div class="search-ctn">
            <div class="search-ctn-left">
                <div class="flex">
                    <div class="search-name">汽配编码</div>
                    <div>
                        <el-input class="search-item" size="small" v-model.trim="searchData.APCode" placeholder="汽配编码"></el-input>
                    </div>
                    <div class="search-name">汽配名称</div>
                    <el-input v-model.trim="searchData.APName" class="search-item" size="small" style="width: 200px" placeholder="汽配名称"></el-input>
                    <div class="search-name">适用车型</div>
                    <el-input v-model.trim="searchData.AutoSerise" class="search-item" size="small" style="width: 200px" placeholder="适用车型"></el-input>
                    <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                    <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
                    <el-button size="small" class="search-btn btn-primary" v-if="showprintAllLabel" @click="printAllLabel()">全部打印</el-button>
                </div>
            </div>
        </div>
        <div class="table-ctn">
            <el-table
                :header-cell-style="{ background: '#F2F6FC' }"
                v-loading="loading"
                :data="tableData"
                border
                ref="multipleTable"
                max-height="500px"
                style="width: 100%; margin-bottom: 10px"
                @sort-change="changeTableSort"
            >
                <el-table-column fixed show-overflow-tooltip sortable width="200" prop="APCode" :sort-method="sortAuthor1" label="汽配编码"></el-table-column>
                <el-table-column show-overflow-tooltip min-width="200" sortable prop="GoodName" :sort-method="sortAuthor2" label="配件名称"></el-table-column>
                <el-table-column show-overflow-tooltip min-width="200" prop="AutoSerise" label="适用车型"></el-table-column>
                <el-table-column show-overflow-tooltip width="60" prop="Unit" label="单位"></el-table-column>
                <el-table-column show-overflow-tooltip width="80" prop="Count" label="采购数量"></el-table-column>
                <el-table-column show-overflow-tooltip width="80" prop="WarehousedCount" label="已入仓数"></el-table-column>
                <el-table-column show-overflow-tooltip width="80" prop="PrintCount" label="已打印数"></el-table-column>
                <el-table-column show-overflow-tooltip width="110" label="标签打印状态">
                    <template slot-scope="scope">
                        <span>{{ scope.row.Count - scope.row.PrintCount == 0 ? '已打印标签' : scope.row.PrintCount == 0 ? '未打印标签' : '已部分打印' }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="105">
                    <template slot-scope="scope">
                        <div class="ops-ctn">
                            <el-button title="查看标签" size="mini" type="text" @click="showCheckLabelsDialog(scope.row)" v-if="scope.row.PrintCount > 0">查看标签</el-button>
                            <el-button
                                title="打印商品标签"
                                size="mini"
                                type="text"
                                @click="printLabel(scope.row)"
                                v-if="
                                    scope.row.WarehousedCount > scope.row.InLabelCount
                                        ? scope.row.Count - scope.row.PrintCount - (scope.row.WarehousedCount - scope.row.InLabelCount) > 0
                                        : scope.row.Count - scope.row.PrintCount > 0
                                "
                                >打印</el-button
                            >
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <el-dialog :close-on-click-modal="false" title="查看商品标签" :visible.sync="showLabelsDialog" width="1200px" append-to-body>
                <div class="dialog-content" v-if="showLabelsDialog">
                    <checkGoodsLabels @closeDialog="closeCheckLabelsDialog" :EntpPOId="entpPOId" :EntpGoodsId="entpGoodsId"></checkGoodsLabels>
                </div>
            </el-dialog>
            <el-dialog :close-on-click-modal="false" title="商品标签打印配置" :visible.sync="showPrintSingleLabelsDialog" width="600px" append-to-body>
                <div class="dialog-content" v-if="showPrintSingleLabelsDialog">
                    <printSingleLabelSet @closeDialog="closePrintSingleLabelsDSialog" :EntpPOId="entpPOId" :EntpGoodsId="entpGoodsId"></printSingleLabelSet>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import checkGoodsLabels from '@/components/business/goods/checkGoodsLabels.vue';
import printSingleLabelSet from '@/components/business/goods/printSingleLabelSet.vue';
export default {
    name: '',
    props: { EntpPOId: String },
    components: {
        checkGoodsLabels,
        printSingleLabelSet
    },
    data() {
        return {
            showPrintSingleLabelsDialog: false,
            showLabelsDialog: false,
            loading: false,
            entpGoodsId: '',
            entpPOId: '',
            showprintAllLabel: false,
            searchData: {
                EntpCusPOId: '',
                APName: '',
                APCode: '',
                AutoSerise: '',
            },
            tableData: [],
            apCodeSort:'',//记录排序，全部打印的时候应用
            apCodePorp:''
        };
    },
    mounted() {
        this.getTableData();
        this.searchData.EntpCusPOId = this.EntpPOId;
        this.entpPOId = this.EntpPOId;
    },
    methods: {
        resetSearch() {
            this.searchData = {
                EntpCusPOId: this.EntpPOId,
                APName: '',
                APCode: '',
                AutoSerise: ''
            };
        },
        getTableData() {
            let that = this;
            if (this.EntpPOId) {
                that.loading = true;
                that.$util
                    .axiosGet({
                        url: '/api/EntpGoodsLabels/GetPrintPurOrderDetail',
                        data: this.searchData
                    })
                    .then(res => {
                        let data = res.data;
                        if (data) {
                            that.tableData = data;
                            for (let i = 0; i < data.length; i++) {
                                that.showprintAllLabel =
                                    data[i].WarehousedCount > data[i].InLabelCount
                                        ? data[i].Count - data[i].PrintCount - (data[i].WarehousedCount - data[i].InLabelCount) > 0
                                        : data[i].Count - data[i].PrintCount > 0;

                                if (that.showprintAllLabel) break;
                            }
                        }
                        that.loading = false;
                    })
                    .catch(() => {
                        that.loading = false;
                    });
            } else this.$util.warningMsg('未检测到采购订单，请重新操作');
        },
        printLabel(row) {
            let that = this;

            if (row) {
                that.entpGoodsId = row.EntpTempGoodsId;
                that.showPrintSingleLabelsDialog = true;
            } else {
                that.$util.warningMsg('请选择商品进行打印标签');
                return;
            }
        },
        printAllLabel() {
            let that = this;
            that.$util.elConfirm({
                content: '谨慎操作！全部打印会默认一个标签码对应一件商品，确定要打印全部商品的标签吗？',
                noMsg: true,
                confirm() {
                    //传到接口调用打印出来
                    that.$util
                        .axiosPost({
                            url: '/api/EntpGoodsLabels/PrintGoodsLabels',
                            data: {
                                EntpPOId: that.EntpPOId,
                                GoodsId: '',
                                ApCodePorp:that.apCodePorp,
                                ApCodeSort:that.apCodeSort
                            }
                        })
                        .then(res => {
                            if (res.errcode == 0) {
                                that.$util.successMsg('提交打印完成');
                                that.getTableData();
                            } else that.$util.errorMsg(res.errmsg);
                        });
                }
            });
        },
        changeTableSort(column){    
            //获取字段名称和排序类型
            var sortingType = column.order;
            this.apCodeSort = sortingType;
            var sortingPorp = column.prop;
            this.apCodePorp = sortingPorp;
        },
        // sortAuthor1(a, b) { ///排序会应用到全部打印这里，但是el-ui的排序用的编码不一样这里处理一下和后端一样
        //     console.log(a)
        //     return a.APCode.localeCompare(b.APCode)
        // },
        sortAuthor1(a, b) {
            let res = 0
            var str1 = a.APCode;
            var str2 = b.APCode;
            for (let i = 0; ;i++) {
            if (!str1[i] || !str2[i]) {
                res = str1.length - str2.length
                break
            }
            const char1 = str1[i]
            const char1Type = this.getChartType(char1)
            const char2 = str2[i]
            const char2Type = this.getChartType(char2)
            // 类型相同的逐个比较字符
            if (char1Type[0] === char2Type[0]) {
                if (char1 === char2) {
                continue
                } else {
                if (char1Type[0] === 'zh') {
                    res = char1.localeCompare(char2)
                } else if (char1Type[0] === 'en') {
                    res = char1.charCodeAt(0) - char2.charCodeAt(0)
                } else {
                    res = char1 - char2
                }
                break
                }
            } else {
            // 类型不同的，直接用返回的数字相减
                res = char1Type[1] - char2Type[1]
                break
            }
            }
            return res
        },
        sortAuthor2(a, b) { ///排序会应用到全部打印这里，但是el-ui的排序用的编码不一样这里处理一下和后端一样
            // let reg = /[a-zA-Z0-9]/
            // if(reg.test(x.GoodName)|| reg.test(y.GoodName)){
            //     if(x.GoodName>y.GoodName){
            //         return 1
            //     }else if(x.GoodName<y.GoodName){
            //         return -1
            //     }else{
            //         return 0
            //     }
            // }else{
            //     return x.GoodName.localeCompare(y.GoodName)
            // }
            let res = 0
            var str1 = a.GoodName;
            var str2 = b.GoodName;
            for (let i = 0; ;i++) {
            if (!str1[i] || !str2[i]) {
                res = str1.length - str2.length
                break
            }
            const char1 = str1[i]
            const char1Type = this.getChartType(char1)
            const char2 = str2[i]
            const char2Type = this.getChartType(char2)
            // 类型相同的逐个比较字符
            if (char1Type[0] === char2Type[0]) {
                if (char1 === char2) {
                continue
                } else {
                if (char1Type[0] === 'zh') {
                    res = char1.localeCompare(char2)
                } else if (char1Type[0] === 'en') {
                    res = char1.charCodeAt(0) - char2.charCodeAt(0)
                } else {
                    res = char1 - char2
                }
                break
                }
            } else {
            // 类型不同的，直接用返回的数字相减
                res = char1Type[1] - char2Type[1]
                break
            }
            }
            return res
        },
        getChartType(char) {
			// 数字可按照排序的要求进行自定义
			// 数字（0->9）->大写字母（A->Z）->小写字母（a->z）->中文拼音（a->z）
            if (/^[\u4e00-\u9fa5]$/.test(char)) {
                return ['zh', 300]
            }
            if (/^[a-zA-Z]$/.test(char)) {
                return ['en', 200]
            }
            if (/^[0-9]$/.test(char)) {
                return ['number', 100]
            }
            return ['others', 999]
		},
        //关闭订单弹出层
        closeCheckLabelsDialog() {
            this.entpGoodsId = '';
            this.showLabelsDialog = false;
        },
        closePrintSingleLabelsDSialog() {
            this.entpGoodsId = '';
            this.showPrintSingleLabelsDialog = false;
            this.getTableData();
        },
        // 打印
        showCheckLabelsDialog(row) {
            if (row) {
                this.entpGoodsId = row.EntpTempGoodsId;
                this.showLabelsDialog = true;
            } else {
                this.$util.warningMsg('请选择商品进行查看');
                return;
            }
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        }
    }
};
</script>
<style lang="less" scoped>
.searchAp-ctn {
    overflow-y: auto;
}
</style>
